// extracted by mini-css-extract-plugin
export default {"reserve":"Reserve_reserve__Wu4hp"};